import React, { Component } from "react";
import {
  ProgressBar, Button,
  Card, Accordion, OverlayTrigger, Tooltip
} from "react-bootstrap";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import {
  IModuleDetailProps,
  IModuleDetailState
}
  from "../../interfaces/module.interface";
import arrow from '../../assets/images/arrow.svg';
import back from '../../assets/images/back.svg';
import backHover from '../../assets/images/back-hover.svg';
import arrowHover from '../../assets/images/arrow-hover.svg';
import { IRootState } from "../../interfaces";
import { moduleDetailRequest, getSelectedModuleRequest, updateModuleProgressRequest } from "../../action/Module";
import Loader from '../../components/Loader/Loader';
import { ConfirmBox } from "../../helper/SweetAlert";

import { AppRoutes } from '../../config';
const queryString = require("query-string");
class Sub_Module extends Component<IModuleDetailProps, IModuleDetailState> {
  constructor(props: IModuleDetailProps) {
    super(props);
    this.state = {
      search: "",
      moduleName: "",
      endMessage: "",
      module_id: "",
      subModile_ID: "",
      previewCss: "hide-preview",
      moduleDataList: []
    };
  }
  componentDidMount = () => {
    const { search } = this.state
    const data = { search }
    this.getModule()
    this.props.getModuleInfo(data);
    window.scrollTo(0, 0);
  };

  componentDidUpdate = (prevProps: IModuleDetailProps, prevState: IModuleDetailState) => {
    const {
      match,
      location, SelectedModuleReducer
    } = this.props;
    const { isLoading } = SelectedModuleReducer;
    const { params } = match;
    if (params !== prevProps.match.params && params) {
      window.scroll(0, 0)
      this.getModule()
    }
  };


  getModule = () => {
    const { match } = this.props;

    const current: any = match.params;
    const { getSelectedModule } = this.props;
    const data = { id: parseInt(current.subModuleID), module_id: parseInt(current.moduleId) }

    getSelectedModule({
      data
    });
    this.setState({
      module_id: current.moduleId,
      subModile_ID: current.subModuleID
    })
    if(current.subModuleOrder != 1) {
      this.setState({
        previewCss: ""
      })
    }
  }


  updateProgress = (oldData: any) => {
    const { updateModuleProgress } = this.props;
    updateModuleProgress({
      module_id: oldData.module_id, sub_module_id: oldData.id
    })
  }



  toggle = (item: any, index: any) => {
    this.setState({
      endMessage: "",
      moduleName: item.name,
      previewCss: ""
    })
    //console.log("item --- "+JSON.stringify(item));

    this.props.history.push(
      AppRoutes.MY_SUB_MODULE.replace(
        ":moduleId",
        item.id
      )
        .replace(
          ":subModuleID", item && item.sub_modules && item.sub_modules.length > 0 ? item.sub_modules[0].id : null
        )
        .replace(
          ":subModuleOrder", item && item.sub_modules && item.sub_modules.length > 0 ? item.sub_modules[0].module_order : null
        )
    )

    if(item.sub_modules[0].module_order == 1) {
      this.setState({
        previewCss: "hide-preview"
      })
    }
  }


  Subtoggle = (item: any, subItem: any, index: any, length: any) => {
    this.setState({
      endMessage: "",
      previewCss: ""
    })

    this.props.history.push(
      AppRoutes.MY_SUB_MODULE.replace(
        ":moduleId",
        item.id,
      )
        .replace(
          ":subModuleID", subItem.id,
        )
        .replace(
          ":subModuleOrder", subItem.module_order
        )
    )
    if(subItem.module_order == 1) {
      this.setState({
        previewCss: "hide-preview"
      })
    }
    if(length == index+1) {
      this.setState({
        endMessage: "End of Topic."
      })
    }
  }

  next = async (item: any) => {
    var message =
      "<span class='swal2-content-span1'>Have you finished reading this page.</span>";
    
    const { value } = await ConfirmBox({
      title: "<span class='swal2-title-span1'></span>",
      background: "#fff",
      html: message,
      cancelButtonClass: "popup-btn",
      confirmButtonClass: "popup-btn-confirm-module", 
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6"
      });
      if (!value) {
        document.body.className = "";
        return false;
      } else {  
        document.body.className = "";      
        this.setState({
          endMessage: "",
          previewCss: ""
        })
        //// console.log(("next")
        const { moduleDetailReducer } = this.props
        if (!moduleDetailReducer.isLoading && moduleDetailReducer && moduleDetailReducer.moduleData) {
          for (let i = 0; i < moduleDetailReducer.moduleData.length; i++) {
            if (moduleDetailReducer.moduleData[i].id === item.module_id) {
              for (let j = 0; j < moduleDetailReducer.moduleData[i].sub_modules.length; j++) {
                if (moduleDetailReducer.moduleData[i].sub_modules[j].id === item.id) {
                  const data = moduleDetailReducer.moduleData[i].sub_modules[j + 1]
                  const oldData = moduleDetailReducer.moduleData[i].sub_modules[j]
                  const endData = moduleDetailReducer.moduleData[i].sub_modules[j + 2]
                  //// console.log(("endData", endData)
    
                  if (!endData) {
                    this.setState({
                      endMessage: "End of Topic."
                    })
                  }
                  if (data) {
                    this.props.history.push(
                      AppRoutes.MY_SUB_MODULE.replace(
                        ":moduleId",
                        data.module_id
                      )
                        .replace(
                          ":subModuleID", data.id,
                        )
                        .replace(
                          ":subModuleOrder", data.module_order
                        )
                    )
    
                    this.updateProgress(oldData)
                  }
                  else {
                    this.setState({
                      endMessage: "",
                      previewCss: "hide-preview"
                    })
                    const initialdata = moduleDetailReducer.moduleData[i].sub_modules[0]
    
                    this.props.history.push(
                      AppRoutes.MY_SUB_MODULE.replace(
                        ":moduleId",
                        initialdata.module_id,
                      )
                        .replace(
                          ":subModuleID", initialdata.id,
                        )
                        .replace(
                          ":subModuleOrder", initialdata.module_order
                        )
                    )
    
                    this.updateProgress(oldData)
                  }
                }
              }
            }
          }
        }

      }
    

  }

  previous = (item: any) => {
    this.setState({
      endMessage: "",
      previewCss: ""
    })
    const { moduleDetailReducer } = this.props
    if (!moduleDetailReducer.isLoading && moduleDetailReducer && moduleDetailReducer.moduleData) {
      for (let i = 0; i < moduleDetailReducer.moduleData.length; i++) {
        if (moduleDetailReducer.moduleData[i].id === item.module_id) {
          for (let j = 0; j < moduleDetailReducer.moduleData[i].sub_modules.length; j++) {
            if (moduleDetailReducer.moduleData[i].sub_modules[j].id === item.id) {

              const data = moduleDetailReducer.moduleData[i].sub_modules[j - 1]
              if (data) {

                this.props.history.push(
                  AppRoutes.MY_SUB_MODULE.replace(
                    ":moduleId",
                    item.module_id

                  )
                    .replace(
                      ":subModuleID", data.id,

                    )
                    .replace(
                      ":subModuleOrder", data.module_order,

                    )
                )

                if(data.module_order == 1) {
                  this.setState({
                    previewCss: "hide-preview"
                  })
                }
              }
              else {
                this.setState({
                  previewCss: "hide-preview"
                })
              }
            }

          }
        }
      }
    }
  }
  render() {
    const { moduleDetailReducer, SelectedModuleReducer } = this.props;
    const { search, moduleName, endMessage, previewCss, module_id, subModile_ID } = this.state;
    const { moduleData } = SelectedModuleReducer;
    
    return (
      <>
        {moduleDetailReducer && moduleDetailReducer.isLoading && SelectedModuleReducer && SelectedModuleReducer.isLoading ? (
          <Loader />
        ) : (
            <>
              <div className="main-section" id="right-container">
                <div className='col-lg-12 col-md- courses-section video-view-section'>
                <div className="row">
                    <div className="col-lg-12 col-md-12">
                      <div className="course-navbar d-flex align-items-center">
                        <div className="mr-auto course-heading text-capitalize">
                          <h2 className="video-title">
                            <span style={{color: "#cba53c" }}>{moduleData.data ? moduleData.data.module_name : moduleName}  / </span> {moduleData.data ? moduleData.data.title : null}
                          </h2>
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <section className="box-main">
                    <div className="container moduleContainer">
                      <div className="row">
                        <div className="col-lg-8 col-md-12 sub-module-section">
                          {moduleData.totalCount > 0 ?
                            <OverlayTrigger
                              key='top'
                              placement='top'
                              overlay={
                                <Tooltip id={`tooltip-top`}>
                                  {moduleData.totalPercent}% completed
                            </Tooltip>
                              }
                            >
                              <ProgressBar now={moduleData.totalPercent} label={`${moduleData.totalPercent}%`} />
                            </OverlayTrigger>
                            : null}

                          {SelectedModuleReducer.isLoading ?
                            <>
                              <Loader />
                            </>
                            : moduleData.data ?
                              <>
                                <div >
                                  <h2 className="view-video-title mt-4">{moduleData.data ? moduleData.data.title : null}</h2>

                                </div>

                                <div className="module-wrap" dangerouslySetInnerHTML={{
                                  __html: `${moduleData.data ? moduleData.data.description : null}`
                                }} />

                                {endMessage ?
                                  <div className="view-video-title">

                                    <span className="custom-rounded">

                                      {endMessage}
                                    </span>
                                  </div>

                                  : null}

                              </> : <div><h6 className='text-center mandatory'>No Sub Module Found. </h6></div>}




                          {moduleData.data && !SelectedModuleReducer.isLoading ?

                            <>

                              <Button variant="outline-info" className={` btn-prev custom-arrow ${previewCss}`} onClick={() => {
                                this.previous(
                                  moduleData.data
                                )

                              }}>


                                <span className="mr-1">

                                  <img className="main-img" src={back} />
                                  <img className="hover-img" src={backHover} />
                                </span>Previous</Button>
                              <Button variant="outline-info" className="float-right btn-next custom-arrow" onClick={() => {
                                this.next(
                                  moduleData.data
                                )

                              }}> Next <span className="ml-1" id="nextModule">
                                  <img className="main-img" src={arrow} />
                                  <img className="hover-img" src={arrowHover} />

                                </span></Button>

                            </>
                            : null}

                        </div >
                        <div className="col-lg-4 col-md-12 mob-over">
                          <div className="filter-div view-video-filter scrollbar force-overflow view-vid-scroll">
                            <div className="title">
                              <h2>Modules</h2>
                              <span className="border-heading"></span>
                            </div>
                            <Accordion defaultActiveKey={module_id}>
                              {moduleDetailReducer && moduleDetailReducer.moduleData &&
                                moduleDetailReducer.moduleData.length ?
                                moduleDetailReducer.moduleData.map((item: any, index: any) => {
                                  return (
                                    <Card>
                                      <Accordion.Toggle as={Card.Header} eventKey={JSON.stringify(item.id)} className="custom-bg-color cursor-pointer" onClick={() => {
                                        this.toggle(
                                          item, index
                                        )
                                      }}  >
                                        <span>
                                          {index + 1}		.		{item && item.name && item.name.length < 40 ? item.name : item.name.substr(0, 45) + "..."}
                                        </span>
                                        <span className="float-right" ><i className="fas fa-angle-down" style={{fontSize: "24px"}}/> </span>
                                      </Accordion.Toggle>
                                      {item && item.sub_modules && item.sub_modules.length ?
                                        item.sub_modules.map((subItem: any, subIndex: any) => {
                                          // console.log(("ttttt", typeof subItem.id)
                                          return (
                                            <Accordion.Collapse eventKey={JSON.stringify(item.id)}  >
                                              <Card.Body className="pl-5 pt-0 pr-0 sub-card-module" onClick={() => {
                                                this.Subtoggle(
                                                  item, subItem, subIndex, item.sub_modules.length
                                                )
                                              }}>
                                                <span className="pr-2">


                                                  {parseInt(subModile_ID) === subItem.id ?
                                                    <i className="fas fa-circle"></i> :
                                                    <i className="far fa-circle"></i>
                                                  }	</span>
                                                <div>	{subItem.title}</div>
                                              </Card.Body>
                                            </Accordion.Collapse>
                                          );
                                        }) : null}
                                    </Card>
                                  );
                                }) : null}
                            </Accordion>
                          </div>
                        </div>
                      </div>
                    </div >
                  </section >
                </div>
              </div>
            </>)
        }
      </>

    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  moduleDetailReducer: state.moduleDetailReducer,
  SelectedModuleReducer: state.SelectedModuleReducer
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getModuleInfo: (data: any) => {
      dispatch(moduleDetailRequest(data));
    },
    getSelectedModule: (data: any) => {
      dispatch(getSelectedModuleRequest(data));
    },
    updateModuleProgress: (data: any) => {
      dispatch(updateModuleProgressRequest(data));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Sub_Module);